import React from 'react';
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import { setorderBookingDetails } from "../../store/actions/book"; 
import { 
    Box, 
    Typography,
    Button
} from '@mui/material';
import '../BooksOrderConfirmComponent/BooksOrderConfirmComponent.css';
import { useLocation,useNavigate  } from 'react-router-dom';




const BookSuccessComponent =  ({
    bookOrderDetails,
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {state} = useLocation();
   function handleClickPujaSuccess() {
    dispatch(setorderBookingDetails([]));
    navigate("/get-books");   // instead of window.location.href
}
    return (
    <>

        
        <Box
            className='puja-success'
            component="form"
            sx={{
                '& .MuiTextField-root': { m: 1 },
                mx: { xs: 2, sm: 10, md: 20, lg: 30 }, // Adjusts horizontal margin based on screen size
                py: { xs: 10, md: 20 } 
            }}
            noValidate
            autoComplete="off"
        >
            <div>
           
                <Box className="form-control-spacing">
                    <Typography sx={{ pb: 3, fontWeight: '600', color: '#010101' }}>Success:</Typography>
                    <Box className="label-puja-confirm" sx={{ pb: 3 }}>
                        <label>
                          Your order has been <b>successfully</b> placed. You will receive an order confirmation email shortly.
                        </label>

                        <br />
                    </Box>
                </Box>

                <Box sx={{textAlign: 'center'}}>
                    <Button onClick={() => handleClickPujaSuccess()} variant="contained">Home</Button>

                </Box>
            </div>
        </Box>
    </>
  )
}
const mapStateToProps = (state) => {
    return{
        bookOrderDetails: state.book.bookOrderDetails,
    };
  
   }

export default connect(mapStateToProps,{
    
  })(BookSuccessComponent);